import { Icon, type IconProps } from '@iconify/react';
import { Box, type SxProps, type Theme } from '@mui/material';

type IconifyProps = Omit<IconProps, 'icon'> & {
  icon: string;
  sx?: SxProps<Theme>;
};

export default function Iconify({ icon, sx, width = 22, height = 22, ...other }: IconifyProps) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width, height, ...sx }}>
      <Icon icon={icon} width={width} height={height} {...other} />
    </Box>
  );
}

/** Icônes sidebar super-admin (alignées dashboard prestataire) */
export const SIDEBAR_ICONS = {
  dashboard: 'mdi:view-dashboard',
  providers: 'mdi:storefront-outline',
  partnerNav: 'mdi:sort-variant',
  providerTypes: 'mdi:shape-outline',
  users: 'mdi:account-group-outline',
  providerUsers: 'mdi:account-plus-outline',
  categories: 'mdi:tag-multiple-outline',
  statistics: 'mdi:chart-bar',
  performance: 'mdi:speedometer',
  performanceAlerts: 'mdi:bell-alert-outline',
  matchings: 'mdi:compare-horizontal',
  announcements: 'mdi:bullhorn-outline',
  stripe: 'mdi:credit-card-outline',
  cityTransports: 'mdi:train-variant',
  imageModeration: 'mdi:shield-alert-outline',
  googleReviews: 'mdi:star-outline',
  announcementTheme: 'mdi:palette-outline',
  homeTicker: 'mdi:bullhorn-variant-outline',
  urlRedirects: 'mdi:arrow-decision-outline',
  symfonyLogs: 'mdi:text-box-search-outline',
  phpInfo: 'mdi:server',
  settings: 'uil:setting',
  menu: 'eva:menu-2-fill',
} as const;

export function sidebarIcon(name: keyof typeof SIDEBAR_ICONS) {
  return <Iconify icon={SIDEBAR_ICONS[name]} width={22} height={22} />;
}
